// extracted by mini-css-extract-plugin
export default {"container":"KYCLevel2_container__RJL84","main-1":"KYCLevel2_main-1__vYuuj"};